import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const SvgCheckmark = () => (_jsx("svg", Object.assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 14.775l-1 1 5 7h.475l14.3-14.8-1-.975-13.3 12.05L6 14.775z" }, void 0) }), void 0));
//# sourceMappingURL=checkmark.js.map
